@use "variables" as *;

.container {
  position: relative;
  width: 100%;
  display: flex;
  .hoverButtonsStack {
    visibility: hidden;
    position: absolute;
    right: $spacing-m;
    top: 0;
    bottom: 0;
    margin: auto 0;
    align-items: center;
  }
  &:hover .hoverButtonsStack {
    visibility: visible;
  }
}

.hoverButton {
  width: 24px;
  height: 24px;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.25);
}

.hoverButtonIcon {
  font-size: $fontSize-l !important;
}

.type {
  margin: $spacing-xxs 0;
  font-size: $fontSize-s;
  font-weight: normal;
}

.codePartsDiv {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.codePart {
  margin: 0 2px;
}

.name {
  font-size: $fontSize-s;
  font-weight: bold;
  margin: 2px 4px;
}

.description {
  font-size: $fontSize-xs;
  white-space: pre-wrap;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.labelImage {
  height: 21px;
}
